import React, { useEffect, useState } from 'react';
import { Button, Form, Modal, Spinner } from 'react-bootstrap';
import PhoneInput from 'react-phone-number-input';
import 'react-phone-number-input/style.css';
import BlacklistDeleteConfirmModel from './BlacklistDeleteConfirmModel';

const BlacklistModal = ({
  type,
  show,
  onHide,
  onSubmit,
  loading,
  phoneNumber: initialPhoneNumber,
}) => {
  const [phoneNumber, setPhoneNumber] = useState(initialPhoneNumber || '');
  const [phoneNumberError, setPhoneNumberError] = useState({
    error: false,
    message: '',
  });
  const [showConfirm, setShowConfirm] = useState(false);

  useEffect(() => {
    if (type === 'edit' || type === 'delete') {
      setPhoneNumber(initialPhoneNumber || '');
    } else {
      setPhoneNumber('');
    }
  }, [type, initialPhoneNumber]);

  const handleSubmit = (evt) => {
    evt.preventDefault();
    
    if (type === 'delete') {
      onHide();
      setShowConfirm(true);
      return;
    }

    if (!phoneNumber) {
      setPhoneNumberError({
        error: true,
        message: 'Please enter a phone number',
      });
      return;
    }

    onSubmit(phoneNumber);
  };

  const handleDeleteConfirm = () => {
    setShowConfirm(false);
    onSubmit(phoneNumber);
  };


  return (
    <>
    <Modal show={show} onHide={onHide} centered>
      <Modal.Header closeButton>
        <Modal.Title>{type.toUpperCase()} Blacklist Entry</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Form onSubmit={handleSubmit}>
          <Form.Group>
            <Form.Label>Phone Number</Form.Label>
            <PhoneInput
              international
              placeholder="Enter phone number"
              value={phoneNumber}
              onChange={(phone) => {
                setPhoneNumber(phone);
                setPhoneNumberError({ error: false, message: '' });
              }}
              isInvalid={phoneNumberError.error}
              disabled={type === 'delete'}
            />
            <Form.Control.Feedback type="invalid">{phoneNumberError.message}</Form.Control.Feedback>
          </Form.Group>
          <Button type="submit" variant="primary" disabled={loading}>
            {loading && <Spinner animation="border" size="sm" className="mr-2" />}
            {type === 'edit' ? 'Update' : type === 'delete' ? 'Delete' : 'Add'}
          </Button>
        </Form>
      </Modal.Body>
    </Modal>
    {type === 'delete' && (
        <BlacklistDeleteConfirmModel
          show={showConfirm}
          onClose={() => setShowConfirm(false)}
          onConfirm={handleDeleteConfirm}
          phoneNumber={phoneNumber}
        />
      )}
    </>
  );
};

export default BlacklistModal;
